// Enter KeyPress Event is required when in TextArea someone press 'Enter' means sending msg.
const isEnterKeyPressed = function (e) {
    if (e.keyCode == 13) {
        return true;
    }
    return false;
};
export default isEnterKeyPressed;
